/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* An AI Agent session
*/
export class Session {
  /**
  * The session ID
  */
  'id'?: string;
  /**
  * The application name
  */
  'appName'?: string;
  /**
  * The user ID
  */
  'userId'?: string;
  /**
  * The session state
  */
  'state'?: { [key: string]: any; };
  /**
  * The last update timestamp
  */
  'lastUpdateTime'?: number;
  /**
  * List of events in the session
  */
  'events'?: Array<{ [key: string]: any; }>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "appName",
      "baseName": "app_name",
      "type": "string",
      "format": ""
    },
    {
      "name": "userId",
      "baseName": "user_id",
      "type": "string",
      "format": ""
    },
    {
      "name": "state",
      "baseName": "state",
      "type": "{ [key: string]: any; }",
      "format": ""
    },
    {
      "name": "lastUpdateTime",
      "baseName": "last_update_time",
      "type": "number",
      "format": ""
    },
    {
      "name": "events",
      "baseName": "events",
      "type": "Array<{ [key: string]: any; }>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Session.attributeTypeMap;
  }

  public constructor() {
  }
}

